enum SubmitAction {
  ADD,
  UPDATE,
  DELETE,
  BULK_UPLOAD,
}

export default SubmitAction;
